<!-- HelpCenter -->
<template>
  <div class="container">
    <div class="list-box">
      <div class="item" v-for="item in list" :key="item.id" @click="()=>{goHelpDetail(item.id)}">
        <div class="title">{{item.title}}</div>
        <img class="icon-arrow" src="@/assets/helpCenter/back.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config/config'

export default {
  name: 'HelpList',
  props: ['list'],
  data() {
    return {
      
    }
  },
  created() {
    
  },
  methods: {
    goHelpDetail (helpId) {
      window.location.href = `${config.siteRoot}/helpdetail?type=${this.$route.query.type}&id=${helpId}`
    }
  },
  mounted () {
    
  }
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";

.container {
  background: #fff!important;
  box-sizing: border-box;
}

.list-box {
  display: flex;
  flex-direction: column;
  padding: 0 .2rem 0 .44rem;
  background: #fff;
}

.item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 1.04rem;
  font-size: .32rem;
  color: #6c6c74;
  text-align: left;
  box-sizing: border-box;
  box-shadow: inset 0 -1px 0 0 #f4f4f8;
}
.icon-arrow {
  display: block;
  width: .44rem;
  height: .44rem;
}

</style>
